module.exports = __webpack_public_path__ + "static/media/NMA.bc6fa756.png";